import { createAPIModule } from 'utility/redux/apiModuleHelpers';
import { createSelector } from 'reselect';
import { List as ImmutableList } from 'immutable';

const getStateSlice = (state) => state.api.licensing.varieties;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'LICENSING_VARIETIES',
	method: 'POST',
	url: '/licensing/varieties.json',
});

const selectors = {
	cPanelsOptions: createSelector(defaultSelectors.getStateSlice, (slice) =>
		slice.getIn(['data', 'varieties', 'cpanel'], ImmutableList()),
	),
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
